/**
 * Legal Pages content - centralized for easy editing.
 * All texts ajustados à Legislação Angolana e Mundial,
 * protegendo a MUDS - Prestação de Serviços e Comércio Geral (SU), Lda.
 */
export const LEGAL_PAGES = {
    termos: {
        slug: "termos",
        title: "Termos e Condições de Utilização",
        subtitle: "Aplicável a todos os utilizadores da plataforma MeSafa.ao",
        last_update: "Outubro de 2025",
        body: [
            {
                heading: "1. Aceitação dos Termos",
                text: `Ao aceder e utilizar a plataforma MeSafa.ao (adiante a “Plataforma”), o Utilizador declara aceitar integralmente os presentes Termos e Condições de Utilização, bem como a nossa Política de Privacidade. A Plataforma é propriedade e é operada por MUDS - Prestação de Serviços e Comércio Geral (SU), Lda, com sede em Avenida Che Guevara n.º 66–68, Edifício Elo Business, Escritório n.º 13, Maculusso, Luanda, República de Angola. Caso não concorde com qualquer disposição, deve abster-se de utilizar a Plataforma.`,
            },
            {
                heading: "2. Definições",
                text: `“Plataforma” significa a aplicação web e móvel MeSafa.ao e todos os seus serviços associados. “Utilizador” significa qualquer pessoa singular ou colectiva que crie uma conta. “Conteúdo” significa textos, imagens, vídeos e dados gerados pelo Utilizador. “MUDS” é a entidade responsável pela Plataforma.`,
            },
            {
                heading: "3. Conta de Utilizador",
                text: `O Utilizador é responsável pelas credenciais de acesso e por todas as actividades efetuadas com a sua conta. A MUDS reserva-se o direito de suspender ou cancelar contas em caso de utilização indevida, fraude, violação destes Termos, ou requerimento de autoridade competente.`,
            },
            {
                heading: "4. Serviços e Subscrições",
                text: `A Plataforma dispõe dos planos Económico, Profissional, Empresarial e Agência Personalizado. As funcionalidades disponíveis em cada plano são as descritas na página de Preços, podendo ser actualizadas mediante aviso prévio. Os preços indicados encontram-se em Kwanzas (AOA) ou Dólares Americanos (USD). A facturação é mensal, salvo acordo escrito em contrário.`,
            },
            {
                heading: "5. Conduta do Utilizador",
                text: `O Utilizador compromete-se a não publicar através da Plataforma conteúdos que (i) sejam ilegais, difamatórios, discriminatórios, obscenos ou que incitem ao ódio ou à violência; (ii) infrinjam direitos de propriedade intelectual de terceiros; (iii) contenham malware, esquemas fraudulentos ou phishing; (iv) violem a Lei n.º 22/11, de 17 de Junho (Lei da Protecção de Dados Pessoais de Angola), o RGPD ou qualquer outra legislação aplicável.`,
            },
            {
                heading: "6. Conteúdo do Utilizador",
                text: `O Utilizador mantém a propriedade do Conteúdo que cria. Ao publicar, concede à MUDS uma licença não-exclusiva, mundial, livre de royalties, exclusivamente para os fins necessários à prestação do serviço (armazenamento, distribuição nas redes sociais conectadas pelo Utilizador, geração de relatórios). A MUDS não se responsabiliza pelo Conteúdo.`,
            },
            {
                heading: "7. Marketplace MeSafa® (Publicidade B2B)",
                text: `Os planos Profissional, Empresarial e Agência podem submeter anúncios ao Marketplace. Cada anúncio está sujeito a aprovação prévia da equipa MeSafa. A MUDS reserva-se o direito de recusar anúncios que violem estes Termos, a legislação aplicável, ou que sejam contrários à imagem da Plataforma. O anunciante é único responsável pelo conteúdo do anúncio e pela legalidade do serviço anunciado.`,
            },
            {
                heading: "8. Limitação de Responsabilidade",
                text: `A Plataforma é fornecida “como está”. A MUDS não garante que o serviço esteja livre de erros ou interrupções e não se responsabiliza por: (a) decisões comerciais tomadas com base em conteúdo gerado por IA; (b) restrições ou suspensões impostas pelas plataformas de redes sociais conectadas; (c) perdas indirectas, lucros cessantes, danos morais ou de imagem decorrentes do uso ou indisponíbilidade do serviço, salvo nos casos em que tal limitação seja proibida pela lei aplicável.`,
            },
            {
                heading: "9. Alterações",
                text: `A MUDS pode alterar a qualquer momento estes Termos, comunicando ao Utilizador através da Plataforma ou por correio electrónico. A continuação do uso após a notificação equivale à aceitação das alterações.`,
            },
            {
                heading: "10. Lei Aplicável e Foro",
                text: `Estes Termos são regidos pela legislação da República de Angola. Para qualquer litígio decorrente da interpretação ou execução, fica eleito como competente o foro do Tribunal Provincial de Luanda, com expressa renúncia a qualquer outro.`,
            },
        ],
    },
    privacidade: {
        slug: "privacidade",
        title: "Política de Privacidade",
        subtitle: "Conformidade com a Lei n.º 22/11 de Angola e RGPD da União Europeia",
        last_update: "Outubro de 2025",
        body: [
            {
                heading: "1. Responsável pelo Tratamento",
                text: `MUDS - Prestação de Serviços e Comércio Geral (SU), Lda, com sede em Avenida Che Guevara n.º 66–68, Edifício Elo Business, Escritório n.º 13, Maculusso, Luanda, Angola. Para questões de privacidade contacte: geral@mesafa.ao.`,
            },
            {
                heading: "2. Dados Recolhidos",
                text: `(i) Dados de identificação: nome, email, telefone, empresa, país. (ii) Dados de pagamento e comprovativos. (iii) Conteúdo criado pelo Utilizador. (iv) Dados técnicos: endereço IP, cookies, registos de acesso. (v) Tokens de acesso às redes sociais autorizadas pelo Utilizador.`,
            },
            {
                heading: "3. Finalidades",
                text: `Os dados são tratados para: (i) prestação do serviço; (ii) facturação e cumprimento de obrigações fiscais perante a Administração Geral Tributária – AGT; (iii) atendimento e suporte; (iv) comunicações de serviço; (v) segurança e prevenção de fraude; (vi) cumprimento de obrigações legais.`,
            },
            {
                heading: "4. Base Legal",
                text: `Execução do contrato (Art. 6.º/1/b RGPD), interesse legítimo (Art. 6.º/1/f), consentimento (Art. 6.º/1/a) e cumprimento de obrigações legais (Art. 6.º/1/c).`,
            },
            {
                heading: "5. Partilha",
                text: `Não vendemos dados. Podemos partilhá-los com (i) prestadores de serviços (cloud, pagamentos, IA) sob contratos de tratamento de dados; (ii) autoridades públicas mediante requerimento legal; (iii) plataformas de redes sociais conectadas pelo Utilizador, exclusivamente para publicar o conteúdo autorizado.`,
            },
            {
                heading: "6. Conservação",
                text: `Os dados são conservados pelo prazo necessário à finalidade e até 5 anos após o encerramento da conta para fins fiscais e de defesa em juízo, salvo prazos legais superiores.`,
            },
            {
                heading: "7. Direitos do Titular",
                text: `Acesso, rectificação, apagamento, oposição, limitação do tratamento, portabilidade. Para exercê-los: geral@mesafa.ao.`,
            },
            {
                heading: "8. Cookies",
                text: `Utilizamos cookies essenciais (sessão), de preferência (idioma, moeda) e estatísticas. Pode gerir cookies no seu navegador.`,
            },
            {
                heading: "9. Segurança",
                text: `Aplicamos encriptação em trânsito (TLS), encriptação de palavras-passe (bcrypt), controlo de acesso e auditoria. Em caso de incidente, comunicaremos nos prazos legais.`,
            },
        ],
    },
    sla: {
        slug: "sla",
        title: "Acordo de Nível de Serviço (SLA)",
        subtitle: "Compromissos de disponibilidade e suporte",
        last_update: "Outubro de 2025",
        body: [
            {
                heading: "1. Disponibilidade",
                text: `A MUDS compromete-se a manter a Plataforma com disponibilidade mínima mensal de 99,5% para todos os planos. As janelas de manutenção programada são excluídas do cálculo. O plano Agência Personalizado pode ter SLA superior, mediante contrato específico.`,
            },
            {
                heading: "2. Tempos de Resposta de Suporte",
                text: `Plano Económico: até 48h úteis. Plano Profissional: até 24h úteis. Plano Empresarial: até 8h úteis (incidentes críticos até 4h). Plano Agência: 24/7 com gestor de conta dedicado.`,
            },
            {
                heading: "3. Janelas de Manutenção",
                text: `As manutenções programadas serão efectuadas, sempre que possível, em horário nocturno (00:00–05:00 GMT), com aviso prévio mínimo de 48 horas.`,
            },
            {
                heading: "4. Compensação",
                text: `Em caso de incumprimento da disponibilidade contratual durante 3 meses consecutivos, o Utilizador tem direito a 1 mês de subscrição gratuita ou crédito proporcional. A compensação não se aplica a indisponíbilidades causadas por: (i) falhas das redes sociais terceiras; (ii) força maior; (iii) ataques DDoS de larga escala; (iv) actos do próprio Utilizador.`,
            },
            {
                heading: "5. Procedimento de Reclamação",
                text: `Reclamações de SLA devem ser apresentadas a suporte@mesafa.ao até 30 dias após o incidente, com descrição e datas/horas afectadas.`,
            },
        ],
    },
    reembolso: {
        slug: "reembolso",
        title: "Política de Reembolso e Cancelamento",
        subtitle: "Como cancelar a sua subscrição e em que condições há lugar a reembolso",
        last_update: "Outubro de 2025",
        body: [
            {
                heading: "1. Cancelamento Voluntario",
                text: `O Utilizador pode cancelar a sua subscrição a qualquer momento através da área “Planos e Subscrição”. O cancelamento produz efeitos no fim do período já pago, mantendo o Utilizador acesso ao plano até à data de término.`,
            },
            {
                heading: "2. Reembolso por Insatisfação (7 dias)",
                text: `Para novos clientes que efectuem o primeiro pagamento, é garantido reembolso integral mediante pedido escrito a geral@mesafa.ao até 7 (sete) dias corridos após a confirmação do pagamento, desde que (i) seja a primeira subscrição do Utilizador; (ii) não tenha publicado mais de 5 conteúdos; (iii) não exista qualquer indício de fraude ou má-fé.`,
            },
            {
                heading: "3. Reembolso por Indisponíbilidade",
                text: `Conforme cláusula 4 do SLA, o Utilizador pode requerer crédito proporcional em caso de indisponíbilidade superior à contratada.`,
            },
            {
                heading: "4. Reembolsos não Aplicáveis",
                text: `Não haverá lugar a reembolso (i) por uso parcial do período já pago; (ii) por violação destes Termos, suspensão ou cancelamento por má utilização; (iii) após 7 dias da confirmação de pagamento, salvo cláusula 3; (iv) sobre valores pagos a terceiros (ex.: ads pagos no Facebook/Instagram).`,
            },
            {
                heading: "5. Forma e Prazo do Reembolso",
                text: `O reembolso é efectuado pelo mesmo método de pagamento utilizado, em Kwanzas (AOA), no prazo máximo de 30 dias úteis após a aprovação do pedido.`,
            },
            {
                heading: "6. Factura-recibo",
                text: `Em caso de reembolso, será emitida nota de crédito pela MUDS – Prestação de Serviços e Comércio Geral (SU), Lda, conforme legislação angolana.`,
            },
        ],
    },
    aviso_legal: {
        slug: "aviso-legal",
        title: "Aviso Legal",
        subtitle: "Informações legais sobre a entidade que opera a Plataforma",
        last_update: "Outubro de 2025",
        body: [
            {
                heading: "1. Identificação",
                text: `A Plataforma MeSafa.ao é propriedade e é operada por MUDS - Prestação de Serviços e Comércio Geral (SU), Lda, sociedade comercial unipessoal por quotas, registada na República de Angola. Sede: Avenida Che Guevara n.º 66–68, Edifício Elo Business, Escritório n.º 13, Maculusso, Luanda. Contacto: geral@mesafa.ao | +244 951 184 329.`,
            },
            {
                heading: "2. Propriedade Intelectual",
                text: `A marca “MeSafa.ao”, o logotipo, o código, o design e os textos da Plataforma são propriedade exclusiva da MUDS, protegidos pela Lei n.º 15/14 (Direito de Autor e Direitos Conexos) e pela Lei n.º 3/92 (Marcas e Patentes) da República de Angola, bem como pelos tratados internacionais aplicáveis. Qualquer utilização não autorizada é expressamente proibida.`,
            },
            {
                heading: "3. Hiperligações",
                text: `A Plataforma pode conter ligações a stios externos (ex: Facebook, Instagram, LinkedIn). A MUDS não controla nem se responsabiliza pelo conteúdo desses sites.`,
            },
            {
                heading: "4. Confidencialidade",
                text: `As informações trocadas entre o Utilizador e a equipa MeSafa, nomeadamente através do BootChat de suporte, são tratadas com confidencialidade.`,
            },
            {
                heading: "5. Resolução Alternativa de Litígios",
                text: `A MUDS propõe a resolução amigável de qualquer litígio. Caso não seja possível, fica competente o Tribunal Provincial de Luanda.`,
            },
            {
                heading: "6. Compromisso Tributário",
                text: `A MUDS cumpre as suas obrigações perante a Administração Geral Tributária – AGT, incluindo a retenção e entrega de impostos aplicáveis. As facturas-recibo são emitidas pela MUDS, mediante solicitação do cliente, após a confirmação do pagamento.`,
            },
        ],
    },
};

export const LEGAL_LINKS = [
    { to: "/termos", label: "Termos e Condições" },
    { to: "/privacidade", label: "Política de Privacidade" },
    { to: "/sla", label: "Acordo SLA" },
    { to: "/reembolso", label: "Reembolso e Cancelamento" },
    { to: "/aviso-legal", label: "Aviso Legal" },
];
